"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsxRuntime = require("react/jsx-runtime");

function StatsLine(_ref) {
  let {
    min,
    max,
    value,
    text,
    temporaryValue,
    iconURL,
    rightText,
    invertColors
  } = _ref;

  if (isNaN(value)) {
    value = 0;
  }

  if (!temporaryValue) {
    temporaryValue = value;
  }

  const positiveColor = !invertColors ? 'tgb-blue' : 'tgb-red';
  const negativeColor = !invertColors ? 'tgb-red' : 'tgb-blue';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tgb-graph-wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tgb-graph ".concat(temporaryValue < value ? negativeColor : ''),
      style: {
        width: "".concat(value / max * 100, "%"),
        zIndex: temporaryValue < value ? 0 : 1
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tgb-graph ".concat(temporaryValue < value ? '' : positiveColor),
      style: {
        zIndex: temporaryValue < value ? 1 : 0,
        width: "".concat(temporaryValue / max * 100, "%")
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tgb-horizontal-wrapper",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "tgb-icon",
        src: iconURL,
        alt: "icon"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: text
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tgb-stats-wrapper",
      children: rightText ? "".concat(value, " ").concat(rightText) : value
    })]
  });
}

var _default = StatsLine;
exports.default = _default;